const download3dFile = async (
  player,
  fileInfo,
  apiConfig,
  progressMsg = () => {},
  downloadEndMsg = () => {}
) => {
  const isExists = await player.Native.File.exists(fileInfo.url)
  if (isExists) {
    return { type: 0, success: true }
  }
  // 模型中转文件
  const tempsUrl = fileInfo.url
  // 处理下载进度方法
  const processFun = (file, bytesReceived, bytesTotal) => {
    progressMsg(file, bytesReceived, bytesTotal)
  }
  // 处理下载结束方法
  const downloadEndFun = async (file, err) => {
    // const tempsMd5 = await player.Native.File.getFileMd5(tempsUrl)
    // if (tempsMd5 === fileInfo.md5) {
    //   // 移动文件到指定文件夹
    await player.Native.File.move(tempsUrl, fileInfo.url)
    if (fileInfo.fileType === 'zip') {
      await player.Native.UiQt.decompressingZIP(fileInfo.url, '')
    }
    // } else {
    //   app.$message.warning('当前请求的md5和服务器下载的md5不一致！')
    // }
    downloadEndMsg(file, err)
    player.Native.File.EventDownloadProcessChanged.disconnect(processFun)
    player.Native.File.EventDownloadFinish.disconnect(downloadEndFun)
  }
  // 监听下载进度
  player.Native.File.EventDownloadProcessChanged.connect(processFun)
  // 监听下载结束
  player.Native.File.EventDownloadFinish.connect(downloadEndFun)
  const res = await player.Native.File.downloadFile(
    tempsUrl,
    apiConfig.method,
    apiConfig.path,
    apiConfig.headers
  )
  return { type: 1, success: res }
}

const download3dFileVk = async (
  player,
  params,
  downloadProcessVk = () => {},
  downloadMaterialFinishVk = () => {}
) => {
  const tempsUrl = params[0]
  const processFun = (file, bytesReceived, bytesTotal) => {
    downloadProcessVk(file, bytesReceived, bytesTotal)
  }
  const downloadEndFun = async (file, err, bytesTotal) => {
    await player.Native.File.move(tempsUrl, params[0])
    const splitRes = params[0].split('.')
    const fileType = splitRes[splitRes.length - 1]
    console.log('下载的文件类型', fileType)
    if (fileType === 'zip') {
      await player.Native.File.unZip(params[0], '')
    }
    downloadMaterialFinishVk(file, err, bytesTotal)
    player.Native.File.EventDownloadProcessChanged.disconnect(processFun)
    player.Native.File.EventDownloadFinish.disconnect(downloadEndFun)
  }
  player.Native.File.EventDownloadProcessChanged.connect(processFun)
  player.Native.File.EventDownloadFinish.connect(downloadEndFun)
  const res = await player.Native.File.downloadFile(...params)
  if (res) {
    return true
  }
  return false
}

export { download3dFile, download3dFileVk }
